var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    padding: _vm.setRem(_vm.getModelIdVal(_vm.moData, 'inside')),
    background: _vm.getModelIdVal(_vm.moData, 'bgcolor'),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }